<div class="modal-header border-0">
  <h4 class="modal-title" id="modal-basic-title">{{ title() }}</h4>
  <button
    type="button"
    class="btn btn-close btn-sm"
    aria-label="Close"
    (click)="userAction('dismiss')"
  ></button>
</div>
<div class="modal-body py-0">
  <!-- Select New Primary Line -->
  <div class="modal-text-size">
    <span class="normalize-external-styles" [innerHTML]="message() | domSanitizer"></span>
  </div>
  <!-- Update Primary Lines -->
  @if (!hideConfirmMessage()) {
    <div [ngClass]="['modal-text-size fw-medium', compact() ? 'mt-2' : 'mt-3']">
      {{ confirmMessage() }}
    </div>
  }
</div>
<div [ngClass]="['modal-footer border-0', compact() ? 'px-3 pb-3' : 'p-3']">
  <div class="d-flex gap-3 d-md-flex d-xs-flex d-sm-flex justify-content-md-end">
    <button class="btn btn-outline-secondary" type="button" (click)="userAction('cancel')">
      <span [ngClass]="['d-inline-block', !compact() ? 'px-2' : '']">{{ cancelButtonText() }}</span>
    </button>
    <button class="btn btn-primary" type="button" (click)="userAction('confirm')">
      {{ confirmButtonText() }}
    </button>
  </div>
</div>
